export enum VisualProminence {
    Normal = "Normal",
    Noticeable = "Noticeable",
    Prominent = "Prominent",
    Dominant = "Dominant"
}